export default "__VITE_ASSET__VkdS7Ese__"